import React from 'react';
import {
  Activity,
  Target,
  TrendingUp,
  Heart,
  BookOpen,
} from 'lucide-react';
import { mockData } from '../../mock';

const ICON_MAP = {
  Activity,
  Target,
  TrendingUp,
  Heart,
  BookOpen,
};

const WhyZeevaSection = () => {
  const { whyZeeva } = mockData;

  return (
    <section
      id="why-zeeva"
      className="section-padding bg-section"
      data-testid="why-zeeva-section"
    >
      <div className="container">
        <div className="text-center mb-12 max-w-3xl mx-auto">
          <h2 className="section-title">{whyZeeva.title}</h2>
          <p
            className="section-subtitle"
            style={{ fontWeight: 600, marginBottom: '1rem' }}
          >
            {whyZeeva.headline}
          </p>
          <p
            className="section-description"
            style={{
              fontStyle: 'italic',
              color: 'var(--text-secondary, rgba(255,255,255,0.8))',
            }}
            data-testid="why-zeeva-philosophy"
          >
            {whyZeeva.philosophy}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {whyZeeva.principles.map((principle) => {
            const Icon = ICON_MAP[principle.icon] || Activity;
            return (
              <div
                key={`principle-${principle.title}`}
                className="reason-card"
                data-testid={`why-zeeva-principle-${principle.title.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <div
                  className="service-icon"
                  style={{ marginBottom: '1rem' }}
                  aria-hidden="true"
                >
                  <Icon size={28} />
                </div>
                <h3 className="reason-title">{principle.title}</h3>
                <p className="reason-description">{principle.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyZeevaSection;
